const httpConfig = {
    //baseURL: "http://KKBank.kinlink.cn/",
    baseURL: "https:///app.auwallet.io/",
    // baseURL: "https://kkbapitest.auwallet.io/",
    //baseURL: "http://192.168.1.25",
    //baseURL: "/api",
    timeout: 15 * 1000, // Timeout
    //withCredentials: true, // Check cross-site Access-Control
}
export default httpConfig
